import Invoices from "../../../../pages/Masters/Invoices";
import Detail from "../../../../pages/Masters/Invoices/Detail"

const routerInvoices = [
    {
        key: "invoices",
        path: "/masters/invoices",
        element: <Invoices />,
    },
    {
        key: "invoices",
        path: "/masters/invoices/:id",
        element: <Detail />,
    }, 
]

export default routerInvoices
